import { styled } from 'lib/styled'

export const Separator = styled.hr(({ noMargin }) => ({
  marginBlock: noMargin ? 0 : '1.5625em',
  '& + div': {
    marginBottom: '1.5em',
  },
}))
